import { introPoints } from "@/mocks/site";

export default function Intro() {
  return (
    <section id="intro" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
            Genre Overview
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            什么是“韩国伦理电影”
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            “伦理电影”并不是一个严格的学术名词，而是观众与市场对一类韩国剧情片的统称。它们通常以婚恋、欲望、
            家庭关系与人性抉择作为主要冲突，情感张力往往盖过情节本身，也因此格外依赖演员的表演与导演的调度。
            理解这个类型，最好从它关心的几个问题入手。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {introPoints.map((point) => (
            <article
              key={point.title}
              className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 flex flex-col"
            >
              <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${point.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {point.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{point.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 md:mt-10 rounded-lg bg-secondary-100/80 border border-secondary-200 p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
          <span className="w-12 h-12 shrink-0 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
            <i className="ri-lightbulb-flash-line text-2xl"></i>
          </span>
          <p className="text-sm md:text-base text-secondary-900 leading-relaxed">
            对很多影迷来说，这一类型的魅力不在“尺度”，而在于它敢把人性里最矛盾的部分摊开来讲。
            把注意力放回叙事结构、表演与美术，往往能获得比猎奇更持久的观影体验。
          </p>
        </div>
      </div>
    </section>
  );
}